import { Component, OnInit, Pipe } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssessmentsService } from '../../shared/services/assessments.service';
import { DownloadService } from '../../shared/services/html-png/html-png.service';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
declare var require: any;
require('highcharts/highcharts-more')(Highcharts);
import { Configuration } from '../../app.constants';
import { TrainingService } from '../../shared/services/training.service';

@Component({
  selector: 'app-assess-visu',
  templateUrl: './assess-visu.component.html',
  styleUrls: ['./assess-visu.component.css']
})
export class AssessVisuComponent implements OnInit {
  
  assessData: any = false;
  assocId = '';
  assocName = '';
  assocGroupId = '';
  motherLangFlag = ''
  workCountryImage = '';
  successorDetails = {
    successorImage: '',
    name: '',
    groupId: '',
    title: '',
    organization: '',
    age: null,
    associateId:''
  };
  education = {
    degree: '-',
    domain: '-',
    year: '',
    country: ''
  };
  isNewEmployee = false;
  calibrationInformation = [];
  nineBoxTitles = {
    High: {
      High: 'High Potential',
      Medium: 'Growing Potential',
      Low: 'Enigma'
    },
    Medium: {
      High: 'Strong Expert',
      Medium: 'Expert',
      Low: 'Inconsistent Player'
    },
    Low: {
      High: 'High Professional',
      Medium: 'Solid Professional',
      Low: 'Lower Professional'
    },
    undefined: {undefined: ''}
  };
  
  highestEducationRanks = {
    'Skills for Life / Vocational Training': 1,
    'GCSE / Equivalent': 2,
    'A - Levels / Equivalent': 3,
    'Diploma': 4,
    'Bachelors Degree(without Honours)': 5,
    'Bachelors Degree(Honours)': 6,
    'Masters / MBA': 7,
    'Doctoral / Post Doctorate': 8
  };
  digitalTotalScore = 80;
  potentialTotalScore = 27;
  performanceTotalScore = 30;
  developmentPlans: any = false; //  filled by highest manager
  leadershipData: any = false; //  filled by highest manager
  successorData: any = false; //  filled by highest manager
  latestPerfPot = {   //  filled by highest manager
    performance: '',
    potential: ''
  };
  calibration= {
    doneByName: '',
    calibratedOn: ''
  };

  // tslint:disable-next-line:max-line-length
  langToCountry = {'english': 'uk', 'french': 'france', 'german': 'germany', 'spanish': 'spain', 'italian': 'italy', 'mandarin': 'china', 'polish': 'poland', 'portuguese': 'portugal', 'afrikaans': 'south africa', 'albanian': 'albania', 'arabic': 'saudia arab', 'armenian': 'armenia', 'bengali': 'india', 'cantonese': 'hong kong', 'catalan': 'andorra', 'croatian': 'croatia', 'czech': 'czech', 'danish': 'denmark', 'dutch': 'holland', 'estonian': 'estonia', 'finnish': 'finland', 'filipino': 'philippines', 'galician': 'spain', 'greek': 'greece', 'hindi': 'india', 'hungarian': 'hungary', 'indonesian': 'indonesia', 'japanese': 'japan', 'korean': 'korea', 'latvian': 'latvia', 'lithuanian': 'lithuania', 'macedonian': 'macedonia ', 'malagasy': 'madagascar', 'malay': 'malaysia', 'norwegian': 'norway', 'romanian': 'romania', 'russia': 'russia', 'serbian': 'serbia', 'slovakian': 'slovakia', 'slovenian': 'slovenia', 'swedish': 'sweden', 'tamil': 'india', 'thai': 'thailand', 'turkish': 'turkey', 'ukrainian': 'ukraine', 'vietnamese': 'vietnam ', 'zulu': 'south africa'};

  highChartsSkillChart;
  visuData: any = false;
  highChartsSkillSetData = {

      chart: {
          polar: true,
          type: 'area',
          height: 450,
          width: 550,
          marginBottom: -350,
          marginLeft: 110,
          marginRight: 110,
          marginTop: -350,
          style: {
              color: "#000000",
              fontSize:'18px'
          }
      },
      title: {
          text: '',
      },
      xAxis: {
          categories: ['Business', 'Strategy', 'Technical', 'Management', 'Entrepreneurship', 'Communication', 'Improvement', 'Engagement'],
          tickmarkPlacement: 'on',
          lineWidth: 0,
          labels: {
            style: {
               color: '#000000',
               fontSize:'18px'
            }
         },
      },
      plotOptions: {
          area: {
            fillOpacity: 0.3
          }
        },
      yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 1,
          min: 0,
          max: 5,
          tickInterval: 1,
          labels: {
            style: {
               color: '#000000',
               fontSize:'18px'
            }
         },
      },
      legend: {
          enabled: false
      },
      series: [{
          name: 'Skills',
          data: [],
          pointPlacement: 'on'
      }]
  };
  public serverApiUrl;
  public trainingNameFromId: any = false;


  constructor( public route: ActivatedRoute,
    public htmlPngService: DownloadService,
    private trainingService:TrainingService,
    private AssessmentsServiceObj: AssessmentsService,
    public config: Configuration) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.route.params.subscribe(params => {
        this.assocId = params['assocId'];
        this.getAssessData();
        this.getVisualizationData();
    });
    this.trainingService.getAllCourses({},{name: 1} ,0,50000)
      .subscribe(data=>{
        this.trainingNameFromId = [];
          data['data'].forEach(element => {
            this.trainingNameFromId[element._id] = element.name;
          });;
      });
  }

  downloadPdf(year = null) {
    this.AssessmentsServiceObj.printVisualization(this.assocId, year).then(res => {
      this.downloadFile(res);
    }).catch(err => {
      console.log(err);
    });
  }

  downloadFile(data){
    console.log('abou tot download');
    var blob = new Blob([data], { type: 'application/pdf' });
    var url= window.URL.createObjectURL(blob);
    console.log(url);
    window.open(url);
  }

  getAssessData(year = null) {
    this.AssessmentsServiceObj.getAssessQuestionsPublic(this.assocId, year).then(response => {
      this.assocName = response['assoc']['personalInformation']['fullName'];
      this.assocGroupId = response['assoc']['groupId'];
      this.assessData = response;

      let fullResponse = response;
      var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
      var firstDate = new Date(fullResponse['assoc'].jobDescription.jobStartDate);
        var secondDate = new Date();
        var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
        if(diffDays < 183){
          this.isNewEmployee = true;
        }

      this.assessData.assoc.workExperience.experience = this.assessData.assoc.workExperience.experience.sort(function(a, b){return new Date(b.startDate).getTime() - new Date(a.startDate).getTime()});

      if (this.langToCountry[this.assessData.assoc.languages.native.trim().toLowerCase()]) {
        this.AssessmentsServiceObj.getFlag(this.langToCountry[this.assessData.assoc.languages.native.trim().toLowerCase()]).then(flag => {
          this.motherLangFlag = flag['flag'];
        }).catch(err => {
          console.log(err);
        });
      }
      this.AssessmentsServiceObj.getFlag(this.assessData.assoc.workContactDetails.workCountry).then(flag => {
        this.workCountryImage = flag['flag'];
      }).catch(err => {
        console.log(err);
      });
      if (this.assessData.assoc.qualificationsAndTrainings.formalEducation.length) {
        let highestEducationIndex = 0;
        let highestEducationDegree = 0;
        for(let i=0 ; i<this.assessData.assoc.qualificationsAndTrainings.formalEducation.length ; i++){
          if(this.highestEducationRanks[this.assessData.assoc.qualificationsAndTrainings.formalEducation[i].degreeName] > highestEducationDegree){
            highestEducationIndex = i;
            highestEducationDegree = this.highestEducationRanks[this.assessData.assoc.qualificationsAndTrainings.formalEducation[i].degreeName];
          }
        }
        this.education.degree = this.assessData.assoc.qualificationsAndTrainings.formalEducation[highestEducationIndex].degreeName;
        this.education.domain = this.assessData.assoc.qualificationsAndTrainings.formalEducation[highestEducationIndex].domain;
        this.education.year = this.assessData.assoc.qualificationsAndTrainings.formalEducation[highestEducationIndex].endDate;
        this.education.country = this.assessData.assoc.qualificationsAndTrainings.formalEducation[highestEducationIndex].schoolCountry;
      }
      this.developmentPlans = this.assessData.answers[0].line.development;
      this.leadershipData = this.assessData.answers[0].line.leadership;
      this.successorData = this.assessData.answers[0].line.successor;
      this.latestPerfPot.performance = this.assessData.answers[0].line.performance;
      this.latestPerfPot.potential = this.assessData.answers[0].line.potential;
      this.calibrationInformation.push({
        text: 'Line Manager',
        name: this.assessData.answers[0].line.doneByName,
        id: this.assessData.answers[0].line.doneById,
        datee: this.assessData.answers[0].line.assessedOn
      });
      for(let i=0 ; i<this.assessData.answers[0].higherManagers.length ; i++) {
        if(this.assessData.answers[0].higherManagers[i].isPlanned && this.assessData.answers[0].higherManagers[i].isLeadershipDone){
          this.calibrationInformation.push({
            text: this.assessData.answers[0].higherManagers[i].managerType + ' Manager Review' ,
            name: this.assessData.answers[0].higherManagers[i].doneByName,
            id: this.assessData.answers[0].higherManagers[i].doneById,
            datee: this.assessData.answers[0].higherManagers[i].plannedOn
          });
          this.calibration['doneByName'] = this.assessData.answers[0].higherManagers[i].doneByName;
          this.calibration['calibratedOn'] = this.assessData.answers[0].higherManagers[i].plannedOn;
          this.developmentPlans = this.assessData.answers[0].higherManagers[i].development;
          this.leadershipData = this.assessData.answers[0].higherManagers[i].leadership;
          this.successorData = this.assessData.answers[0].higherManagers[i].successor;
          this.latestPerfPot.performance = this.assessData.answers[0].higherManagers[i].performance;
          this.latestPerfPot.potential = this.assessData.answers[0].higherManagers[i].potential;
        }
      }
      if(this.visuData){
        this.updatePerfPotInVisuData();
      }
    }).catch(err => {
      console.log(err);
    });
  }

  updatePerfPotInVisuData(){
    this.visuData.forEach(indAssess => {
        if(indAssess.year === 2018){
          indAssess.potential = this.latestPerfPot.potential;
          indAssess.performance = this.latestPerfPot.performance;
        }
    });
  }

  getVisualizationData(year = null) {
    this.AssessmentsServiceObj.getVisualizationDataPublic(this.assocId, year).then(response => {
      this.visuData = response['assessments'];
      if(this.latestPerfPot.performance){
        this.updatePerfPotInVisuData();
      }
      this.successorDetails = response['successorDetails'];
      if (this.visuData.length) {
        this.highChartsSkillSetData.series[0].data = [];
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['businessProcessUnderstanding']);
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['strategicThinking']);
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['technicalKnowledge']);
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['managementSkills']);
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['entreprenuership']);
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['communication']);
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['improvementAbility']);
        this.highChartsSkillSetData.series[0].data.push(this.visuData[0]['engagement']);
      }
      this.highChartsSkillChart = new Chart(this.highChartsSkillSetData);
    }).catch(err => {
      console.log(err);
    });
  }

  splitString(str: String, char){
    if(str){
      return str.split(char);
    } else {
      return [];
    }
  }

}
